import React, { useState } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { useTheme } from "../../core";
import { KTSVG, toAbsoluteUrl } from "../../../helpers";
import { AsideMenu } from "./AsideMenu";
import { MenuModal } from "../../../partials";
import { MenuInner } from "../header/MenuInner";

export function AsideDefault() {
  const { config, classes } = useTheme();
  const [showMegaMenuModal, setShowMegaMenuModal] = useState(false);

  return (
    <>
      {config.aside.display && (
        <div
          id="kt_aside"
          className={clsx("aside", "bg-info", classes.aside.join(" "))}
          data-kt-drawer="true"
          data-kt-drawer-name="aside"
          data-kt-drawer-activate="{default: true, lg: false}"
          data-kt-drawer-overlay="true"
          data-kt-drawer-width={
            config.aside.secondaryDisplay
              ? "{default:'200px', '300px': '250px'}"
              : "70px"
          }
          data-kt-drawer-direction="start"
          data-kt-drawer-toggle="#kt_aside_toggler"
        >
          {config.aside.primaryDisplay && (
            <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">
              <div
                className="aside-logo d-flex flex-column align-items-center flex-column-auto py-4 pt-lg-10 pb-lg-7"
                id="kt_aside_logo"
              >
                <Link to="/">
                  <img
                    alt="Logo"
                    src={toAbsoluteUrl("/media/logos/logo-compact.svg")}
                    className="mh-50px"
                  />
                </Link>
              </div>

              <div
                className="aside-nav d-flex flex-column align-items-center flex-column-fluid pt-0 pb-5"
                id="kt_aside_nav"
              >
                <div
                  // data-kt-scroll="true"
                  // data-kt-scroll-height="auto"
                  // data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
                  // data-kt-scroll-wrappers="#kt_aside_nav"
                  // data-kt-scroll-offset="10px"
                >
                  <ul className="nav flex-column">
                    <li className="nav-item mb-1" title="Home">
                      <Link 
                        to="/"
                        className="nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white"
                      >
                        <KTSVG
                          className="svg-icon-2 svg-icon-lg-1"
                          path="/media/icons/duotone/Home/Home.svg"
                        />
                      </Link>
                    </li>

                    <li className="nav-item mb-1" title="Settings">
                      <Link 
                        to="/profile/settings"
                        className="nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white"
                      >
                        <KTSVG
                          className="svg-icon-2 svg-icon-lg-1"
                          path="/media/icons/duotone/Interface/Cog.svg"
                        />
                      </Link>
                    </li>

                    <li className="nav-item mb-1" title="User Profile">
                      <Link 
                        to="/profile/account"
                        className="nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white"
                      >
                        <KTSVG
                          className="svg-icon-2 svg-icon-lg-1"
                          path="/media/icons/duotone/Interface/User.svg"
                        />
                      </Link>
                    </li>

                  </ul>
                </div>
              </div>

              <div
                className="aside-footer d-flex flex-column align-items-center flex-column-auto py-5 py-lg-7"
                id="kt_aside_footer"
              >
                {config.aside.secondaryDisplay && config.aside.toggle && (
                  <button
                    className={`btn btn-sm btn-icon btn-white btn-active-primary position-absolute translate-middle start-100 end-0 bottom-0 shadow-sm d-none d-lg-flex ${classes.asideToggle.join(
                      " "
                    )}`}
                    id="kt_aside_toggle"
                    data-kt-toggle="true"
                    data-kt-toggle-state="active"
                    data-kt-toggle-target="body"
                    data-kt-toggle-name="aside-minimize"
                    title="Toggle Aside"
                  >
                    <KTSVG
                      path="/media/icons/duotone/Navigation/Left-2.svg"
                      className="svg-icon-2 rotate-180"
                    />
                  </button>
                )}

                  {/* <button
                    type="button"
                    className="btn btn-custom h-40px w-40px h-lg-50px w-lg-50px btn-icon btn-color-white"
                    data-kt-menu-trigger="click"
                    data-kt-menu-overflow="true"
                    data-kt-menu-placement="top-start"
                    data-kt-menu-flip="top-end"
                  > */}
                {/* begin::Mega Menu Toggler */}
                <div
                  className="mb-2"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  data-bs-trigger="hover"
                  title="Help"
                >
                  <Link
                      to="/help"
                      className="btn btn-custom h-40px w-40px h-lg-50px w-lg-50px btn-icon btn-color-white"
                      data-kt-menu-dismiss="true"
                      title="Help"
                    >
                    <KTSVG
                      className="svg-icon-2 svg-icon-lg-1"
                      path="/media/icons/duotone/Code/Question-circle.svg"
                    />
                  </Link>
                </div>
                <div
                  className="mb-2"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  data-bs-trigger="hover"
                  title="Sign out"
                >
                  <Link
                      to="/logout"
                      className="btn btn-custom h-40px w-40px h-lg-50px w-lg-50px btn-icon btn-color-white"
                      data-kt-menu-dismiss="true"
                      title="Sign out"
                    >
                    <KTSVG
                      className="svg-icon-2 svg-icon-lg-1"
                      path="/media/icons/duotone/Interface/Sign-Out.svg"
                    />
                  </Link>
                </div>
              </div>
            </div>
          )}

          {config.aside.secondaryDisplay && (
            <div className="aside-secondary d-flex flex-row-fluid">
              <div
                className="aside-workspace my-7 ps-5 pe-4 ps-lg-10 pe-lg-6"
                id="kt_aside_wordspace"
              >
                {!config.aside.primaryDisplay ? (
                  <>
                    {/* begin::Logo */}
                    <div className="aside-logo py-2 pb-7" id="kt_aside_logo">
                      <Link to="/">
                        <img
                          alt="Logo"
                          src={toAbsoluteUrl("/media/logos/logo-compact.svg")}
                          className="mh-50px"
                        />
                      </Link>
                    </div>
                    {/* end::Logo */}
                    <AsideMenu
                      menuType={config.aside.menu}
                      asidePrimaryDisplay={config.aside.primaryDisplay}
                    />
                  </>
                ) : (
                  <div className="tab-content">
                    <div
                      className="tab-pane fade show active"
                      id="kt_aside_tab_1"
                    >
                      <AsideMenu
                        menuType={config.aside.menu}
                        asidePrimaryDisplay={config.aside.primaryDisplay}
                      />
                    </div>

                    {/* begin::Demo menu */}
                    <div className="tab-pane fade" id="kt_aside_tab_2">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book.
                    </div>
                    {/* end::Demo menu */}

                    {/* begin::Demo menu */}
                    <div className="tab-pane fade" id="kt_aside_tab_3">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book.
                    </div>
                    {/* end::Demo menu */}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      
      <MenuModal
        show={showMegaMenuModal}
        handleClose={() => setShowMegaMenuModal(false)}
      >
        <MenuInner />
      </MenuModal>
    </>
  );
}
